import { createContext,useContext, useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useCode } from './Code'

// Crear el contexto
export const CompanyContext = createContext();

export function useCompany() {
    return useContext(CompanyContext);
  }

// Crear el proveedor del contexto
export const CompanyProvider = ({ children }) => {
    const {code} = useCode()
    const [company, setCompany] = useState(null);

    useEffect(() => {
        const getCompany = async () => {
            if (code){
                const { data: companyData, error } = await supabase
                    .from('companies')
                    .select('*')
                    .eq('id', code)
                    .single()
                    .limit(1);
                if (error) {
                    console.error('Error al obtener la información de la empresa:', error);
                    setCompany(null)
                } else {
                    setCompany(companyData);
                }
            } else {
                setCompany(null)
            }
        };

        getCompany();
    }, [code]);

    return (
        <CompanyContext.Provider value={company}>
            {children}
        </CompanyContext.Provider>
    );
};
